/**
 * ReaderAppBanner — shown ONLY when the user is running inside the
 * Capacitor native iOS/Android shell. Apple's App Store rules permit
 * apps to display content the user paid for elsewhere ("reader apps"
 * — Spotify, Netflix, Kindle pattern). We must NOT show in-app
 * purchase CTAs that route to the web; we may show plain copy
 * telling existing subscribers where their subscription lives.
 *
 * On iOS we deliberately use the most conservative copy (no external
 * link, just text). On Android we can be slightly more direct.
 *
 * Render this near the top of every screen that shows pricing /
 * upgrade CTAs on the web. Conditionally hide the web's "Buy"
 * buttons next to it with `useReaderAppMode()`.
 */
import React from "react";
import { isNativeApp } from "@/lib/nativeBridge";

export function ReaderAppBanner() {
  // US storefront link-out allowance (3.1.1): purchases are permitted
  // via the default browser. This banner tells native users exactly
  // where checkout happens. Non-US native users never reach the pages
  // that render this banner (they are redirected before it mounts).
  if (!isNativeApp()) return null;
  return (
    <div
      className="mb-5 rounded-xl border border-[#E8D9A6] bg-[#FBF7EC] px-4 py-3 text-[13px] text-[#3F3F3F] leading-relaxed"
      data-testid="native-browser-checkout-banner"
    >
      Purchases open in your default browser and are completed securely
      on armstrongk9registry.com.
    </div>
  );
}

/** Returns true when buy-CTAs should be hidden / replaced with
 *  sign-in copy because we're rendering inside the native app. */
export function useReaderAppMode() {
  return isNativeApp();
}
